/* eslint-disable @typescript-eslint/no-unsafe-return */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/no-unsafe-argument */
/* eslint-disable no-nested-ternary */
/* eslint-disable jsx-a11y/label-has-associated-control */
import { yupResolver } from '@hookform/resolvers/yup';
import { AxiosError } from 'axios';
import "core-js/actual/array/with";
import React, { useEffect, useMemo, useState } from 'react';
import { useFieldArray, useForm, useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { ErrorInfo, PsTextCondition, PsTextConditionDrawing, PsTextConditionFlist } from '../../../../api/model';
import { useGetPsDrawingNoList, useGetPsFeatureList, useGetPsItemList, useGetPsSectionList, useGetPsTextConditionList } from '../../../../api/pss/pss';
import { useDefaultOptions } from '../../../../hooks/api';
import { getNextId } from '../../../../utils/id';
import { toString } from '../../../../utils/string';
import { CheckBox } from '../../../atoms/CheckBox';
import ErrorComponent from '../../../atoms/ErrorComponent';
import SingleSelectWithFilter from '../../../atoms/SingleSelectWithFilter';
import { TextInput } from '../../../atoms/TextInput';
import WaitComponent from '../../../atoms/WaitComponent';
import Modal from "../../../modules/Modal";
import OkModal from '../../../modules/OkModal';
import { PsTextConditionSchemaType, psTextConditionSchema } from './constants/variables';

interface Props {
  /** モーダル表示・非表示状態。 */
  isOpen: boolean;

  /** モーダル表示・非表示状態設定関数。 */
  setIsOpen: (isOpen: boolean) => void;

  /** 新規追加モード / 編集モード */
  mode: string;

  /** 操作対象となるテキスト確定条件の index。 */
  psTextConditionIndex: number;

  // /** 編集対象の現在の値。 */
  // currentValues?: PsTextConditionsSchemaType | undefined;
}

// PS 編集画面で使用。
/** テキスト確定条件追加・編集ダイアログ。 */
function PsTextConditionAddEditDialog(
  {
    isOpen,
    setIsOpen,
    mode,
    psTextConditionIndex,
    // currentValues,
  }: Props
) {

  // i18n 用。
  const {
    t,
    i18n,
  } = useTranslation();

  const defaultOptions = useDefaultOptions(i18n.language);

  /** テキスト確定条件リスト取得 API 呼び出し。 */
  const getPsTextConditionListResponse = useGetPsTextConditionList(defaultOptions);
  /** 図面番号リスト取得 API 呼び出し。 */
  const getPsDrawingNoListResponse = useGetPsDrawingNoList(defaultOptions);
  /** Section リスト取得 API 呼び出し。 */
  const getPsSectionListResponse = useGetPsSectionList(defaultOptions);
  /** Feature リスト取得 API 呼び出し。 */
  const getPsFeatureListResponse = useGetPsFeatureList(defaultOptions);
  /** Item リスト取得 API 呼び出し。 */
  const getPsItemListResponse = useGetPsItemList(defaultOptions);

  // /** 操作対象の PsTextCondition の React Hook Form 用の name。 */
  // const targetPsTextConditionName = `text_conditions.${psTextConditionIndex}`;

  // 参照: https://qiita.com/y-yasuda/items/9184380d3320d47bc564
  // PsDetails に置かれた FormProvider から取得。
  const {
    // register, 
    // formState, 
    control: contextControl,
    getValues: contextGetValues,
    // setValue: contextSetValue
  } = useFormContext();

  // text_conditions 用。
  const {
    // fields: textConditionFields,
    append: appendTextCondition,
    update: updateTextCondition,
    // remove: removeTextCondition,
  } = useFieldArray({
    control: contextControl,
    name: 'text_conditions' as const,
  });

  const textConditions = contextGetValues('text_conditions');

  /** 次の ID 生成のためにテキスト確定条件の ID の配列を取得。 */
  const textConditionIds = useMemo(
    () =>
      (Array.isArray(textConditions)) ?
        textConditions.map(
          (psTextCondition: PsTextCondition) =>
            (typeof psTextCondition.text_condition_id === 'number') ?
              psTextCondition.text_condition_id
              :
              0
        )
        :
        [],
    [textConditions]
  );

  // const {
  //   getNextId: getNextTextConditionId,
  // } = useNextId(textConditionIds);

  // console.log('getNextTextConditionId(): ', getNextTextConditionId());


  // /** 過去の prop との比較用。 */
  // const [previousMode, setPreviousMode] = useState<string>(mode);

  const defaultValues: PsTextConditionSchemaType = useMemo(
    () =>
      (
        // 新規追加なら Schema からデフォルト値を取得し、編集なら useFormContext から値を取得して defaultValues とする。
        (mode === 'Add') ?
          {
            ...psTextConditionSchema.getDefault(),
            // PsDetails でテキスト確定条件の key としているため、unique な値にしたい。
            // text_condition_id: getNextTextConditionId(),
            text_condition_id: getNextId(textConditionIds),
            text_condition: '',
          }
          :
          contextGetValues(`text_conditions.${psTextConditionIndex}`)
      ) as PsTextConditionSchemaType,
    [contextGetValues, mode, psTextConditionIndex, textConditionIds]
  );

  // console.log('defaultValues: ', defaultValues);


  // このダイアログで独立した form を使い、useFormContext と useFieldArray で呼び出し元 (PsDetails) の form の値 (text_conditions) を変更する。
  // React Hook Form。
  const {
    register,
    formState,
    handleSubmit,
    reset,
    control,
    getValues,
    setValue,
    // watch,
  } = useForm<PsTextConditionSchemaType>({
    defaultValues,
    resolver: yupResolver(psTextConditionSchema),
    criteriaMode: 'all',
    mode: 'all',
  });

  // text_condition_drawings 用。
  const {
    fields: textConditionDrawingFields,
    append: appendTextConditionDrawing,
    remove: removeTextConditionDrawing,
  } = useFieldArray({
    control,
    name: 'text_condition_drawings' as never,
  });

  // text_condition_flists 用。
  const {
    fields: textConditionFlistFields,
    append: appendTextConditionFlist,
    remove: removeTextConditionFlist,
  } = useFieldArray({
    control,
    name: 'text_condition_flists' as never,
  });

  const textConditionFlists = getValues('text_condition_flists' as never);

  /** 次の ID 生成のためにテキスト確定条件 FLIST の ID の配列を取得。 */
  const textConditionFlistIds = useMemo(
    () =>
      (Array.isArray(textConditionFlists)) ?
        (textConditionFlists as PsTextConditionFlist[]).map(
          (psTextConditionFlist: PsTextConditionFlist) =>
            (typeof psTextConditionFlist.text_condition_flist_id === 'number') ?
              psTextConditionFlist.text_condition_flist_id
              :
              0
        )
        :
        [],
    [textConditionFlists]
  );


  // /** 編集後、キャンセル ボタン押下で元に戻すために text_conditions を保存しておく state。 */
  // const [textConditionsSnapshot, setTextConditionsSnapshot] = useState<unknown | undefined>(undefined);

  // console.log('textConditionsSnapshot: ', textConditionsSnapshot);

  // useEffect(
  //   () => {
  //     if (isOpen && (typeof textConditionsSnapshot === 'undefined')) {
  //       // ダイアログが開かれた。
  //       // text_conditions のスナップショットを保存。
  //       setTextConditionsSnapshot(contextGetValues('text_conditions'));

  //       // if (mode === 'Add') {
  //       //   // 新規追加モードの場合。

  //       //   // TODO?: 保存 (更新) ボタン押下で最後に追加する方法はあるのか？
  //       //   // 末尾に追加する。
  //       //   appendTextCondition({
  //       //     text_condition_id: null,
  //       //     text_condition: null,
  //       //     text_condition_drawings: [],
  //       //     text_condition_flists: [],
  //       //     service_spec_table: null,
  //       //     tos: null,
  //       //     hg_check_require: null,
  //       //   });
  //       // }
  //     }
  //   },
  //   [appendTextCondition, contextGetValues, isOpen, mode, textConditionsSnapshot]
  // );

  // /** このダイアログを閉じる時の動作。 */
  // const onClose = () => {
  //   // // スナップショットをクリアー。
  //   // setTextConditionsSnapshot(undefined);

  //   // ダイアログを閉じる。
  //   setIsOpen(false);
  // };

  // /** 変更を反映せずにダイアログを閉じる時の動作。 */
  // const onCancel = () => {
  //   // // このダイアログを開く前の状態に戻す。
  //   // contextSetValue('text_conditions', textConditionsSnapshot);

  //   onClose();
  // };

  // API 関連の状態。

  const isLoading =
    (getPsTextConditionListResponse.isLoading)
    ||
    (getPsDrawingNoListResponse.isLoading)
    ||
    (getPsSectionListResponse.isLoading)
    ||
    (getPsFeatureListResponse.isLoading)
    ||
    (getPsItemListResponse.isLoading);

  const isReady =
    (getPsTextConditionListResponse.isSuccess)
    &&
    (getPsTextConditionListResponse.data.data)
    &&
    (getPsDrawingNoListResponse.isSuccess)
    &&
    (getPsDrawingNoListResponse.data.data)
    &&
    (getPsSectionListResponse.isSuccess)
    &&
    (getPsSectionListResponse.data.data)
    &&
    (getPsFeatureListResponse.isSuccess)
    &&
    (getPsFeatureListResponse.data.data)
    &&
    (getPsItemListResponse.isSuccess)
    &&
    (getPsItemListResponse.data.data);

  let axiosError: AxiosError<ErrorInfo, unknown> | undefined;

  if (getPsTextConditionListResponse.isError) {
    axiosError = getPsTextConditionListResponse.error;
  }
  if (getPsDrawingNoListResponse.isError) {
    axiosError = getPsDrawingNoListResponse.error;
  }
  if (getPsSectionListResponse.isError) {
    axiosError = getPsSectionListResponse.error;
  }
  if (getPsFeatureListResponse.isError) {
    axiosError = getPsFeatureListResponse.error;
  }
  if (getPsItemListResponse.isError) {
    axiosError = getPsItemListResponse.error;
  }

  // /** <select> の <option> の value と label となるデータの先頭のもの。 */
  // const defaultOptionData = useMemo(
  //   () => ({
  //     value: '',
  //     label: t('選択してください'),
  //   }),
  //   [t]
  // );

  /** このダイアログの各種ドロップダウンの options のデータの型。 */
  type OptionData = {
    value: string;
    label: string;
  };

  /** SingleSelectWithFilter に渡す関数。 */
  const getValue = (optionData: OptionData) => optionData.value;
  /** SingleSelectWithFilter に渡す関数。 */
  const getLabel = (optionData: OptionData) => optionData.label;

  /** SingleSelectWithFilter (prop の options) に渡すデータに変換する関数。 */
  const toOptionsData = (data: string[]) =>
    data.map(
      (value: string) => ({
        value,
        label: value,
      })
    );

  // /** option など、UI 関連の値を設定し終わったか否か。 */
  // const [isInitialUiDataAllSet, setIsInitialUiDataAllSet] = useState<boolean>(false);

  /** 「確定条件」ドロップダウン (select) の候補 (option) 用データとして新規追加したもの (「追加」ボタン → ダイアログで)。 */
  const [addedTextConditionOptionsData, setAddedTextConditionOptionsData] = useState<(OptionData)[]>([]);

  // console.log('addedTextConditionOptionsData', addedTextConditionOptionsData);

  /** テキスト確定条件リスト取得 API の返り値を OptionData にしたものと addedTextConditionOptionsData をマージする。 */
  const textConditionOptionsData = (isReady) ? toOptionsData(getPsTextConditionListResponse.data.data).concat(addedTextConditionOptionsData) : [];

  /** text_condition の select の option に渡すデータ。 */
  // const [textConditionOptionsData, setTextConditionOptionsData] = useState<(OptionData)[]>([]);

  /** 「図面番号」ドロップダウン (select) の候補 (option) 用データとして新規追加したもの (「追加」ボタン → ダイアログで)。 */
  const [addedDwgNoOptionsData, setAddedDwgNoOptionsData] = useState<(OptionData)[]>([]);

  /** 「図面番号」は改廃案保存しても、承認されるまでは追加されないため、このダイアログを開いた時点で、contextGetValues(`text_conditions.${psTextConditionIndex}`) で取得したデータの内、API で取得したデータに存在しない図面番号を保存しておくための state。 */
  const [tmpDwgNoOptionsData, setTmpDwgNoOptionsData] = useState<(OptionData)[]>([]);

  /** 図面番号リスト取得 API の返り値を OptionData にしたものと tmpDwgNoOptionsData と addedDwgNoOptionsData をマージする。 */
  const dwgNoOptionsData = (isReady) ? toOptionsData(getPsDrawingNoListResponse.data.data).concat(tmpDwgNoOptionsData).concat(addedDwgNoOptionsData) : [];

  // /** dwg_no の select の option に渡すデータ。 */
  // const [dwgNoOptionsData, setDwgNoOptionsData] = useState<(OptionData)[]>([]);

  /** 「Section」ドロップダウン (select) の候補 (option) 用データとして新規追加したもの (「追加」ボタン → ダイアログで)。 */
  const [addedSectionOptionsData, setAddedSectionOptionsData] = useState<(OptionData)[]>([]);

  /** Section リスト取得 API の返り値を OptionData にしたものと addedSectionOptionsData をマージする。 */
  const sectionOptionsData = (isReady) ? toOptionsData(getPsSectionListResponse.data.data).concat(addedSectionOptionsData) : [];

  // /** section の select の option に渡すデータ。 */
  // const [sectionOptionsData, setSectionOptionsData] = useState<(OptionData)[]>([]);

  /** 「Feature」ドロップダウン (select) の候補 (option) 用データとして新規追加したもの (「追加」ボタン → ダイアログで)。 */
  const [addedFeatureOptionsData, setAddedFeatureOptionsData] = useState<(OptionData)[]>([]);

  /** Feature リスト取得 API の返り値を OptionData にしたものと addedFeatureOptionsData をマージする。 */
  const featureOptionsData = (isReady) ? toOptionsData(getPsFeatureListResponse.data.data).concat(addedFeatureOptionsData) : [];

  // /** feature の select の option に渡すデータ。 */
  // const [featureOptionsData, setFeatureOptionsData] = useState<(OptionData)[]>([]);

  /** 「Item」ドロップダウン (select) の候補 (option) 用データとして新規追加したもの (「追加」ボタン → ダイアログで)。 */
  const [addedItemOptionsData, setAddedItemOptionsData] = useState<(OptionData)[]>([]);

  /** Item リスト取得 API の返り値を OptionData にしたものと addedItemOptionsData をマージする。 */
  const itemOptionsData = (isReady) ? toOptionsData(getPsItemListResponse.data.data).concat(addedItemOptionsData) : [];

  // /** item の select の option に渡すデータ。 */
  // const [itemOptionsData, setItemOptionsData] = useState<(OptionData)[]>([]);

  // useEffect(
  //   () => {
  //     if (isReady && !isInitialUiDataAllSet) {
  //       // 全データ取得完了時。

  //       /** SingleSelect の prop の options に渡すデータに変換する関数。 */
  //       const toOptionsData = (data: string[]) =>
  //         // 取得したデータの先頭に「選択してください」を足し、値を '' とする。
  //         // [defaultOptionData].concat(
  //         data.map(
  //           (value: string) => ({
  //             value,
  //             label: value,
  //           })
  //         )
  //       // );

  //       // option などを設定する。

  //       setTextConditionOptionsData(
  //         // schema では .required() としてあるので、「選択してください」のままではエラーとなる (「更新」ボタンが押下不可)。
  //         toOptionsData(getPsTextConditionListResponse.data.data)
  //       );

  //       setDwgNoOptionsData(toOptionsData(getPsDrawingNoListResponse.data.data));

  //       setSectionOptionsData(toOptionsData(getPsSectionListResponse.data.data));
  //       setFeatureOptionsData(toOptionsData(getPsFeatureListResponse.data.data));
  //       setItemOptionsData(toOptionsData(getPsItemListResponse.data.data));

  //       // UI 関連の値を設定し終わった。
  //       setIsInitialUiDataAllSet(true);
  //     }
  //   },
  //   [defaultOptionData, getPsDrawingNoListResponse.data?.data, getPsFeatureListResponse.data?.data, getPsItemListResponse.data?.data, getPsSectionListResponse.data?.data, getPsTextConditionListResponse.data?.data, isInitialUiDataAllSet, isReady, t]
  // );

  /** 過去の prop との比較用。 */
  const [previousIsOpen, setPreviousIsOpen] = useState<boolean>(false);

  useEffect(
    () => {
      if (previousIsOpen !== isOpen) {
        // Avoid calling reset before useForm's useEffect is invoked, this is because useForm's subscription needs to be ready before reset can send a signal to flush form state update.
        // It's recommended to reset inside useEffect after submission.

        // form を reset。
        reset(defaultValues);

        // TODO: 確認。今は onClose と合わせて、閉じてから開くまで 3 回 reset を実行しているが、ダイアログを開く時だけ reset ではうまくいかないのはなぜ？

        // console.log('defaultValues on reset: ', defaultValues);
        // console.log('getValues() on reset: ', getValues());
      }

      if (!previousIsOpen && isOpen) {
        // 閉じられていた → 開かれた時。

        if (mode === 'Edit') {
          if (Array.isArray(defaultValues.text_condition_drawings)) {
            // 「図面番号」は改廃案保存しても、承認されるまでは追加されないため、このダイアログを開いた時点で、
            // contextGetValues(`text_conditions.${psTextConditionIndex}`) で取得したデータの内、
            // API で取得したデータに存在しない図面番号を state の tmpDwgNoOptionsData に保存する。
            setTmpDwgNoOptionsData(
              // 追加モード時の defaultValues.text_condition_drawings は getValues で取得した text_conditions[index] の値。
              defaultValues.text_condition_drawings.map(
                (textConditionDrawing: PsTextConditionDrawing) => {
                  const dwgNo = (typeof textConditionDrawing.dwg_no === 'string') ?
                    textConditionDrawing.dwg_no
                    :
                    '';

                  return (
                    {
                      value: dwgNo,
                      label: dwgNo,
                    }
                  );
                }
              )
              // 重複チェックは不要か。
              // .filter(
              //   (newOptionData: OptionData) =>
              //     (typeof newOptionData.value === 'string')
              //     &&
              //     (newOptionData.value.length > 0)
              //     &&
              //     dwgNoOptionsData.every(
              //       (dwgNoOptionData: OptionData) =>
              //         // 重複しないもの。
              //         dwgNoOptionData.value !== newOptionData.value
              //     )
              // )
            );
          }
        }
      }

      if (isOpen !== previousIsOpen) {
        // prop を比較用に保存。
        setPreviousIsOpen(isOpen);
      }
    },
    [defaultValues, isOpen, mode, previousIsOpen, reset]
  );


  // テキストボックスに入力された値を、指定された対象に追加するダイアログ関連の states。
  // const [isTextValueAddDialogOpen, setIsTextValueAddDialogOpen] = useState<boolean>(false);
  /** ↑ のダイアログで「追加」ボタンを押下した時に追加する対象。値は name とする。length > 0 ならダイアログを表示する。 */
  const [targetToAddTextValue, setTargetToAddTextValue] = useState<string>('');
  /** ↑ のダイアログのテキストボックス用の state。 */
  const [textValueToAdd, setTextValueToAdd] = useState<string>('');
  /** ↑ のテキストボックスで入力制限に引っかかった時に表示するメッセージ。 */
  const [errorMessageForTextbox, setErrorMessageForTextbox] = useState<string>('');

  // 各種ドロップダウンに新規追加された options 用データを編集するためのダイアログ関連の states。
  // const [isOptionsDataEditDialogOpen, setIsOptionsDataEditDialogOpen] = useState<boolean>(false);
  /** ↑ のダイアログで「編集」ボタンを押下した時に編集する対象。値は name とする。length > 0 ならダイアログを表示する。 */
  const [targetToEditOptionsData, setTargetToEditOptionsData] = useState<string>('');
  /** ↑ のダイアログの編集対象の state を指す state。 */
  const [targetOptionsData, setTargetOptionsData] = useState<OptionData[]>([]);
  /** ↑ のダイアログのテキストボックシズ用の state。 */
  const [editingOptionsData, setEditingOptionsData] = useState<OptionData[]>([]);
  /** ↑ のテキストボックシズで入力制限に引っかかった時に表示するメッセージ。 */
  const [errorMessagesForTextboxes, setErrorMessagesForTextboxes] = useState<string[]>([]);

  // if (isReady) {
  //   console.log('getPsTextConditionListResponse.data.data: ', getPsTextConditionListResponse.data.data);
  // }

  const onClose = () => {
    // form を reset。
    reset(defaultValues);

    // ダイアログを閉じる。
    setIsOpen(false);
  };

  /** handleSubmit() の SubmitErrorHandler が呼ばれた時、その引数を set する。undefined でない場合、モーダルで内容を表示する。 */
  const [handleSubmitErrors, setHandleSubmitErrors] = useState<unknown>(undefined);

  return (
    <>
      {/* テキスト確定条件追加編集ダイアログ。 */}
      <Modal
        active={isOpen}
        additionalClassName='mtsp popupfr865'
        displayCloseButton
        shouldCloseOnOverlayClick={false}
        onClose={onClose}
      >
        {/* モーダル内部にメッセージを表示。 */}

        {
          (isLoading)
          &&
          (
            <WaitComponent />
          )
        }

        {
          (typeof axiosError !== 'undefined')
          &&
          (
            <ErrorComponent error={axiosError} />
          )
        }

        {
          (isReady)
          // &&
          // (isInitialUiDataAllSet)
          &&
          (
            <>
              <div className="pop-tablefr2">
                <table className="poptable1">
                  <tbody>
                    <tr className="spwide">
                      <th><label>{t('確定条件')}</label></th>
                      <td>
                        <span>
                          <span className='dropdown'>
                            {/* 確定条件ドロップダウン。 */}
                            <SingleSelectWithFilter
                              name={'text_condition' as never}
                              options={textConditionOptionsData}
                              control={control}
                              getValue={getValue as never}
                              getLabel={getLabel as never}
                            />
                            {/* <SingleSelect
                            name={'text_condition' as never}
                            allowEmpty={false}
                            options={textConditionOptionsData}
                            register={register}
                            getValue={getValue}
                            getLabel={getLabel}
                            // watch (または value) を渡して <select> の value を設定するのと、onChange で setValue するとなると、controlled component に近くなるか。
                            // しかし、setValue で値を set しただけでは <select> の見かけ上の選択状態が同期しないから仕方ないか。他に方法はあるか？
                            watch={watch}
                            onChange={
                              (event) => {
                                setValue(
                                  'text_condition' as never,
                                  event.target.value as never,
                                  { shouldValidate: true, shouldDirty: true, shouldTouch: true }
                                );
                              }
                            }
                          /> */}
                          </span>
                        </span>
                        <span
                          className="cursor"
                          onClick={
                            () => {
                              // テキストボックスの値を指定された対象に追加するダイアログの対象を 'text_condition' にして、ダイアログを開く。
                              setTargetToAddTextValue('text_condition');
                              // // テキストボックスの値を指定された対象に追加するダイアログを開く。
                              // setIsTextValueAddDialogOpen(true);
                            }
                          }
                        >
                          <i className="fa-solid fa-circle-plus" />
                          {t('追加')}
                        </span>
                        {
                          (addedTextConditionOptionsData.length > 0)
                          &&
                          (
                            <span
                              className="cursor"
                              style={{
                                marginLeft: '1em',
                              }}
                              onClick={
                                () => {
                                  // 編集対象を「確定条件」ドロップダウンの新規追加された options のデータにする。
                                  setTargetOptionsData([...addedTextConditionOptionsData]);
                                  setEditingOptionsData(addedTextConditionOptionsData);

                                  // ドロップダウンの options 用データを編集するダイアログの対象を 'text_condition' にして、ダイアログを開く。
                                  setTargetToEditOptionsData('text_condition');
                                }
                              }
                            >
                              <i className="fa-solid fa-pen-to-square" />
                              {t('編集')}
                            </span>
                          )
                        }
                      </td>
                    </tr>
                    <tr className="spwide">
                      <th><label>{t('図面')}</label></th>
                      <td>
                        <div className="addfr">
                          <span
                            className="cursor"
                            onClick={
                              () => {
                                // 図面番号、補足説明の入力欄を 1 組追加する。
                                // text_condition_drawing を追加する。
                                appendTextConditionDrawing({
                                  text_condition_drawing_id: null,
                                  drawing_id: null,
                                  dwg_no: '',
                                  supplement: '',
                                });
                              }
                            }
                          >
                            <i className="fa-solid fa-circle-plus" />
                            {t('追加')}
                          </span>
                        </div>

                        {
                          textConditionDrawingFields.map(
                            (textConditionDrawing: Record<'id', string>, textConditionDrawingIndex: number) =>
                            (
                              <React.Fragment
                                key={textConditionDrawing.id}
                              >
                                <div className="deletefr">
                                  <span
                                    className="delete-i cursor"
                                    onClick={
                                      () => {
                                        // 該当する図面番号、補足説明の入力欄を削除する。
                                        // text_condition_drawing を削除する。
                                        removeTextConditionDrawing(textConditionDrawingIndex);
                                      }
                                    }
                                  >
                                    <i className="fa-solid fa-circle-xmark" />
                                    {t('削除')}
                                  </span>
                                </div>

                                <div
                                  className="zumen1"
                                  style={{
                                    width: (addedDwgNoOptionsData.length > 0) ? '480px' : '430px',
                                  }}
                                >
                                  <label>
                                    {t('図面番号')}
                                    <span>{t('(半角英数字5桁)')}</span>
                                  </label>
                                  <span
                                    className="ifr"
                                    style={{
                                      flexBasis: 'calc(100% - 170px)',
                                    }}
                                  >
                                    <span className='dropdown'>

                                      {/* 図面番号ドロップダウン。 */}
                                      <SingleSelectWithFilter
                                        name={`text_condition_drawings.${textConditionDrawingIndex}.dwg_no` as never}
                                        options={dwgNoOptionsData}
                                        control={control}
                                        getValue={getValue as never}
                                        getLabel={getLabel as never}
                                      />
                                      {/* <SingleSelect
                                      name={`text_condition_drawings.${textConditionDrawingIndex}.dwg_no` as never}
                                      allowEmpty={false}
                                      options={dwgNoOptionsData}
                                      register={register}
                                      getValue={getValue}
                                      getLabel={getLabel}
                                      watch={watch}
                                      onChange={
                                        (event) => {
                                          setValue(
                                            `text_condition_drawings.${textConditionDrawingIndex}.dwg_no` as never,
                                            event.target.value as never,
                                            { shouldValidate: true, shouldDirty: true, shouldTouch: true }
                                          );
                                        }
                                      }
                                    /> */}
                                    </span>
                                  </span>

                                  <span
                                    className="addbtn"
                                    onClick={
                                      () => {
                                        // テキストボックスの値を指定された対象に追加するダイアログの対象を 'dwg_no' にして、ダイアログを開く。
                                        setTargetToAddTextValue(`text_condition_drawings.${textConditionDrawingIndex}.dwg_no`);
                                        // // テキストボックスの値を指定された対象に追加するダイアログを開く。
                                        // setIsTextValueAddDialogOpen(true);
                                      }
                                    }
                                  >
                                    <i className="fa-solid fa-circle-plus" />
                                    {t('追加')}
                                  </span>
                                  {
                                    (addedDwgNoOptionsData.length > 0)
                                    &&
                                    (
                                      <span
                                        className="cursor"
                                        style={{
                                          marginLeft: '1em',
                                          flexBasis: '60px',
                                        }}
                                        onClick={
                                          () => {
                                            // エラー メッセージ用 state を初期化。
                                            setErrorMessagesForTextboxes(new Array(addedDwgNoOptionsData.length));

                                            // 編集対象を「図面番号」ドロップダウンの新規追加された options のデータにする。
                                            setTargetOptionsData([...addedDwgNoOptionsData]);
                                            setEditingOptionsData(addedDwgNoOptionsData);

                                            // ドロップダウンの options 用データを編集するダイアログの対象を 'dwg_no' にして、ダイアログを開く。
                                            setTargetToEditOptionsData(`text_condition_drawings.${textConditionDrawingIndex}.dwg_no`);
                                          }
                                        }
                                      >
                                        <i className="fa-solid fa-pen-to-square" />
                                        {t('編集')}
                                      </span>
                                    )
                                  }
                                </div>

                                <div className="zumen2">
                                  <label>{t('補足説明')}</label>
                                  <textarea
                                    rows={5}
                                    cols={33}
                                    {...register(`text_condition_drawings.${textConditionDrawingIndex}.supplement` as never)}
                                  />
                                </div>
                              </React.Fragment>
                            )
                          )
                        }

                      </td>
                    </tr>

                    <tr className="spwide">
                      <th><label>{t('FLIST')}</label></th>
                      <td>
                        <div className="addbtn">
                          <span className="cursor"
                            onClick={
                              () => {
                                // Section、Feature、Item の入力欄を 1 組追加する。
                                // text_condition_flist を追加する。
                                appendTextConditionFlist({
                                  // PsDetails でテキスト確定条件の key としているため、unique な値にしたい。
                                  text_condition_flist_id: getNextId(textConditionFlistIds),
                                  section: '',
                                  feature: '',
                                  item: '',
                                });
                              }
                            }
                          >
                            <i className="fa-solid fa-circle-plus" />
                            {t('追加')}
                          </span>
                        </div>

                        {
                          textConditionFlistFields.map(
                            (textConditionFlist: Record<'id', string>, textConditionFlistIndex: number) =>
                            (
                              <div
                                key={textConditionFlist.id}
                                className="sfi-dpd"
                              // style={{
                              //   width: '480px',
                              // }}
                              >

                                <span
                                  className="delete-i cursor"
                                  onClick={
                                    () => {
                                      // 該当する Section、Feature、Item の入力欄を削除する。
                                      // text_condition_flist を削除する。
                                      removeTextConditionFlist(textConditionFlistIndex);
                                    }
                                  }
                                >
                                  <i className="fa-solid fa-circle-xmark" />
                                  {t('削除')}
                                </span>

                                <ul>

                                  <li>
                                    <label
                                      style={{
                                        flexBasis: '90px',
                                        flexShrink: '0',
                                      }}
                                    >
                                      {t('Section')}
                                    </label>
                                    <span
                                      className="ifr"
                                      style={{
                                        flexBasis: '288px',
                                        flexShrink: '0',
                                      }}
                                    >
                                      <span className='dropdown'>
                                        {/* Section ドロップダウン。 */}
                                        <SingleSelectWithFilter
                                          name={`text_condition_flists.${textConditionFlistIndex}.section` as never}
                                          options={sectionOptionsData}
                                          control={control}
                                          getValue={getValue as never}
                                          getLabel={getLabel as never}
                                        />
                                        {/* <SingleSelect
                                        name={`text_condition_flists.${textConditionFlistIndex}.section` as never}
                                        allowEmpty={false}
                                        options={sectionOptionsData}
                                        register={register}
                                        getValue={getValue}
                                        getLabel={getLabel}
                                        watch={watch}
                                        onChange={
                                          (event) => {
                                            setValue(
                                              `text_condition_flists.${textConditionFlistIndex}.section` as never,
                                              event.target.value as never,
                                              { shouldValidate: true, shouldDirty: true, shouldTouch: true }
                                            );
                                          }
                                        }
                                      /> */}
                                      </span>
                                    </span>

                                    <span
                                      className="addbtn"
                                      style={{
                                        flexBasis: '42px',
                                        flexShrink: '0',
                                      }}
                                      onClick={
                                        () => {
                                          // テキストボックスの値を指定された対象に追加するダイアログの対象を 'section' にして、ダイアログを開く。
                                          setTargetToAddTextValue(`text_condition_flists.${textConditionFlistIndex}.section`);
                                          // // テキストボックスの値を指定された対象に追加するダイアログを開く。
                                          // setIsTextValueAddDialogOpen(true);
                                        }
                                      }
                                    >
                                      <i className="fa-solid fa-circle-plus" />
                                      {t('追加')}
                                    </span>
                                    {
                                      (addedSectionOptionsData.length > 0)
                                      &&
                                      (
                                        <span
                                          className="cursor"
                                          style={{
                                            marginLeft: '1em',
                                            marginBottom: '10px',
                                            flexBasis: '42px',
                                            flexShrink: '0',
                                          }}
                                          onClick={
                                            () => {
                                              // 編集対象を「Section」ドロップダウンの新規追加された options のデータにする。
                                              setTargetOptionsData([...addedSectionOptionsData]);
                                              setEditingOptionsData(addedSectionOptionsData);

                                              // ドロップダウンの options 用データを編集するダイアログの対象を 'section' にして、ダイアログを開く。
                                              setTargetToEditOptionsData(`text_condition_flists.${textConditionFlistIndex}.section`);
                                            }
                                          }
                                        >
                                          <i className="fa-solid fa-pen-to-square" />
                                          {t('編集')}
                                        </span>
                                      )
                                    }
                                  </li>

                                  <li>
                                    <label
                                      style={{
                                        flexBasis: '90px',
                                        flexShrink: '0',
                                      }}
                                    >
                                      {t('Feature')}
                                    </label>
                                    <span
                                      className="ifr"
                                      style={{
                                        flexBasis: '288px',
                                        flexShrink: '0',
                                      }}
                                    >
                                      <span className='dropdown'>

                                        {/* Feature ドロップダウン。 */}
                                        <SingleSelectWithFilter
                                          name={`text_condition_flists.${textConditionFlistIndex}.feature` as never}
                                          options={featureOptionsData}
                                          control={control}
                                          getValue={getValue as never}
                                          getLabel={getLabel as never}
                                        />
                                        {/* <SingleSelect
                                        name={`text_condition_flists.${textConditionFlistIndex}.feature` as never}
                                        allowEmpty={false}
                                        options={featureOptionsData}
                                        register={register}
                                        getValue={getValue}
                                        getLabel={getLabel}
                                        watch={watch}
                                        onChange={
                                          (event) => {
                                            setValue(
                                              `text_condition_flists.${textConditionFlistIndex}.feature` as never,
                                              event.target.value as never,
                                              { shouldValidate: true, shouldDirty: true, shouldTouch: true }
                                            );
                                          }
                                        }
                                      /> */}
                                      </span>
                                    </span>

                                    <span
                                      className="addbtn"
                                      style={{
                                        flexBasis: '42px',
                                        flexShrink: '0',
                                      }}
                                      onClick={
                                        () => {
                                          // テキストボックスの値を指定された対象に追加するダイアログの対象を 'feature' にして、ダイアログを開く。
                                          setTargetToAddTextValue(`text_condition_flists.${textConditionFlistIndex}.feature`);
                                          // // テキストボックスの値を指定された対象に追加するダイアログを開く。
                                          // setIsTextValueAddDialogOpen(true);
                                        }
                                      }
                                    >
                                      <i className="fa-solid fa-circle-plus" />
                                      {t('追加')}
                                    </span>
                                    {
                                      (addedFeatureOptionsData.length > 0)
                                      &&
                                      (
                                        <span
                                          className="cursor"
                                          style={{
                                            marginLeft: '1em',
                                            marginBottom: '10px',
                                            flexBasis: '42px',
                                            flexShrink: '0',
                                          }}
                                          onClick={
                                            () => {
                                              // 編集対象を「Feature」ドロップダウンの新規追加された options のデータにする。
                                              setTargetOptionsData([...addedFeatureOptionsData]);
                                              setEditingOptionsData(addedFeatureOptionsData);

                                              // ドロップダウンの options 用データを編集するダイアログの対象を 'feature' にして、ダイアログを開く。
                                              setTargetToEditOptionsData(`text_condition_flists.${textConditionFlistIndex}.feature`);
                                            }
                                          }
                                        >
                                          <i className="fa-solid fa-pen-to-square" />
                                          {t('編集')}
                                        </span>
                                      )
                                    }
                                  </li>

                                  <li>
                                    <label
                                      style={{
                                        flexBasis: '90px',
                                        flexShrink: '0',
                                      }}
                                    >
                                      {t('Item')}
                                    </label>
                                    <span
                                      className="ifr"
                                      style={{
                                        flexBasis: '288px',
                                        flexShrink: '0',
                                      }}
                                    >
                                      <span className='dropdown'>
                                        {/* Item ドロップダウン。 */}
                                        <SingleSelectWithFilter
                                          name={`text_condition_flists.${textConditionFlistIndex}.item` as never}
                                          options={itemOptionsData}
                                          control={control}
                                          getValue={getValue as never}
                                          getLabel={getLabel as never}
                                        />
                                        {/* <SingleSelect
                                        name={`text_condition_flists.${textConditionFlistIndex}.item` as never}
                                        allowEmpty={false}
                                        options={itemOptionsData}
                                        register={register}
                                        getValue={getValue}
                                        getLabel={getLabel}
                                        watch={watch}
                                        onChange={
                                          (event) => {
                                            setValue(
                                              `text_condition_flists.${textConditionFlistIndex}.item` as never,
                                              event.target.value as never,
                                              { shouldValidate: true, shouldDirty: true, shouldTouch: true }
                                            );
                                          }
                                        }
                                      /> */}
                                      </span>
                                    </span>

                                    <span
                                      className="addbtn"
                                      style={{
                                        flexBasis: '42px',
                                        flexShrink: '0',
                                      }}
                                      onClick={
                                        () => {
                                          // テキストボックスの値を指定された対象に追加するダイアログの対象を 'item' にして、ダイアログを開く。
                                          setTargetToAddTextValue(`text_condition_flists.${textConditionFlistIndex}.item`);
                                          // // テキストボックスの値を指定された対象に追加するダイアログを開く。
                                          // setIsTextValueAddDialogOpen(true);
                                        }
                                      }
                                    >
                                      <i className="fa-solid fa-circle-plus" />
                                      {t('追加')}
                                    </span>
                                    {
                                      (addedItemOptionsData.length > 0)
                                      &&
                                      (
                                        <span
                                          className="cursor"
                                          style={{
                                            marginLeft: '1em',
                                            marginBottom: '10px',
                                            flexBasis: '42px',
                                            flexShrink: '0',
                                          }}
                                          onClick={
                                            () => {
                                              // 編集対象を「Item」ドロップダウンの新規追加された options のデータにする。
                                              setTargetOptionsData([...addedItemOptionsData]);
                                              setEditingOptionsData(addedItemOptionsData);

                                              // ドロップダウンの options 用データを編集するダイアログの対象を 'item' にして、ダイアログを開く。
                                              setTargetToEditOptionsData(`text_condition_flists.${textConditionFlistIndex}.item`);
                                            }
                                          }
                                        >
                                          <i className="fa-solid fa-pen-to-square" />
                                          {t('編集')}
                                        </span>
                                      )
                                    }
                                  </li>

                                </ul>

                              </div>
                            )
                          )
                        }

                      </td>
                    </tr>

                    <tr>
                      <th>
                        <label>{t('サービススペック表')}</label>
                      </th>
                      <td>
                        <TextInput
                          name={'service_spec_table' as never}
                          register={register}
                          errors={formState.errors}
                        />
                      </td>
                    </tr>
                    <tr>
                      <th>
                        <label>{t('その他トス情報')}</label>
                      </th>
                      <td>
                        <TextInput
                          name={'tos' as never}
                          register={register}
                          errors={formState.errors}
                        />
                      </td>
                    </tr>
                    <tr>
                      <th>
                        <label>{t('補足説明')}</label>
                      </th>
                      <td>
                        <textarea
                          rows={5}
                          cols={33}
                          {...register(`tos_supplement` as never)}
                        />
                      </td>
                    </tr>
                    <tr>
                      <th>
                        <label>{t('開発部門確認')}</label>
                      </th>
                      <td>
                        <CheckBox
                          name={'hg_check_require' as never}
                          label={t('開発部門確認が必要')}
                          parentSpanClassName='ck-left2'
                          register={register}
                        />

                        {/* <span className="ck-left2">
                          <input type="checkbox" id="ck49-1" name="checkbox1" />
                          <label htmlFor="ck49-1">開発部門確認が必要</label>
                        </span> */}
                      </td>
                    </tr>

                  </tbody>
                </table>


              </div>

              <div className="btnfr btnfr2w mb0">
                <div>
                  <span
                    className="btn2 btnbg-g"
                    onClick={onClose}
                  >
                    <span className="modal-close2">{t('キャンセル')}</span>
                  </span>
                  <span>
                    <input
                      type="button"
                      value={(mode === 'Add') ? toString(t('追加')) : toString(t('更新'))}
                      className="btn1 lsp1"
                      disabled={!formState.isValid}
                      onClick={
                        handleSubmit(
                          (data: unknown) => {
                            // console.log('handleSubmit data: ', data);
                            // console.log('getValues(): ',
                            //   getValues()
                            // );

                            if (mode === 'Add') {
                              // 新規追加。
                              appendTextCondition(data);
                            }
                            else if (mode === 'Edit') {
                              // 更新。
                              updateTextCondition(psTextConditionIndex, data);
                            }

                            onClose();
                          },
                          (errors: unknown) => {
                            // console.log('handleSubmit errors: ', errors);

                            // モーダルでエラー メッセージを表示する。
                            setHandleSubmitErrors(errors);
                          }
                        )
                      }
                    />
                  </span>
                </div>
              </div>
            </>
          )
        }
      </Modal>

      {/* テキストボックスに入力された値を指定された対象に追加するダイアログ。 */}
      <Modal
        // active={isTextValueAddDialogOpen}
        active={targetToAddTextValue.length > 0}
        additionalClassName='mtsp popupfr865'
        displayCloseButton
        shouldCloseOnOverlayClick={false}
        onClose={
          () => {
            // リセット。
            setTextValueToAdd('');

            // ダイアログを閉じる。
            // setIsTextValueAddDialogOpen(false);
            setTargetToAddTextValue('');
          }
        }
      >
        <label>
          {
            (targetToAddTextValue.endsWith('text_condition')) ?
              t('新規確定条件')
              :
              (targetToAddTextValue.endsWith('dwg_no')) ?
                t('新規図面番号')
                :
                (targetToAddTextValue.endsWith('section')) ?
                  t('新規 Section')
                  :
                  (targetToAddTextValue.endsWith('feature')) ?
                    t('新規 Feature')
                    :
                    (targetToAddTextValue.endsWith('item')) ?
                      t('新規 Item')
                      :
                      ''
          }
          <br />
          <br />
          <input
            type="text"
            value={textValueToAdd}
            onChange={
              (event) => {
                if (
                  // 図面番号。
                  (targetToAddTextValue.endsWith('dwg_no'))
                  &&
                  // 半角英数 5 桁という制限。
                  (!(event.target.value.match(/^[a-zA-Z0-9]{5}$/)))
                ) {
                  // エラー メッセージをセット。
                  setErrorMessageForTextbox(toString(t('半角英数字５桁で入力してください。')));
                }
                else {
                  // エラー メッセージをリセット。
                  setErrorMessageForTextbox('');
                }

                // console.log(`event.target.value.trim(): [${event.target.value.trim()}]`);

                // 値をセット。
                setTextValueToAdd(event.target.value);
              }
            }
          />
        </label>
        {
          (errorMessageForTextbox.length > 0)
          &&
          (
            <>
              <br />
              <span className="form-error">
                {/* エラー メッセージを表示する。 */}
                {errorMessageForTextbox}
              </span>
              <br />
            </>
          )
        }
        <div className="btnfr btnfr2w mb0">
          <div>
            <span
              className="btn2 btnbg-g"
              onClick={
                () => {
                  // リセット。
                  setTextValueToAdd('');

                  // ダイアログを閉じる。
                  // setIsTextValueAddDialogOpen(false);
                  setTargetToAddTextValue('');
                }
              }
            >
              <span className="modal-close2">
                {t('キャンセル')}
              </span>
            </span>
            <span>
              <input
                type="button"
                value={toString(t('追加'))}
                className="btn1 lsp1"
                disabled={(errorMessageForTextbox.length > 0) || (textValueToAdd.trim().length === 0)}
                onClick={
                  () => {
                    const trimmedTextValueToAdd = textValueToAdd.trim();

                    const optionDataToAdd = {
                      value: trimmedTextValueToAdd,
                      label: trimmedTextValueToAdd,
                    };

                    if (targetToAddTextValue.endsWith('text_condition')) {
                      if (textConditionOptionsData.every((optionData) => optionData.value !== trimmedTextValueToAdd)) {
                        // 既存データと重複していない場合。

                        // 新規追加分用 state の末尾に追加。
                        setAddedTextConditionOptionsData(addedTextConditionOptionsData.concat(optionDataToAdd));
                      }
                    }
                    if (targetToAddTextValue.endsWith('dwg_no')) {
                      if (dwgNoOptionsData.every((optionData) => optionData.value !== trimmedTextValueToAdd)) {
                        // 既存データと重複していない場合。

                        // 新規追加分用 state の末尾に追加。
                        setAddedDwgNoOptionsData(addedDwgNoOptionsData.concat(optionDataToAdd));
                      }
                    }
                    if (targetToAddTextValue.endsWith('section')) {
                      if (sectionOptionsData.every((optionData) => optionData.value !== trimmedTextValueToAdd)) {
                        // 既存データと重複していない場合。

                        // 新規追加分用 state の末尾に追加。
                        setAddedSectionOptionsData(addedSectionOptionsData.concat(optionDataToAdd));
                      }
                    }
                    if (targetToAddTextValue.endsWith('feature')) {
                      if (featureOptionsData.every((optionData) => optionData.value !== trimmedTextValueToAdd)) {
                        // 既存データと重複していない場合。

                        // 新規追加分用 state の末尾に追加。
                        setAddedFeatureOptionsData(addedFeatureOptionsData.concat(optionDataToAdd));
                      }
                    }
                    if (targetToAddTextValue.endsWith('item')) {
                      if (itemOptionsData.every((optionData) => optionData.value !== trimmedTextValueToAdd)) {
                        // 既存データと重複していない場合。

                        // 新規追加分用 state の末尾に追加。
                        setAddedItemOptionsData(addedItemOptionsData.concat(optionDataToAdd));
                      }
                    }

                    // console.log('targetToAddTextValue: ', targetToAddTextValue);
                    // console.log('trimmedTextValueToAdd: ', trimmedTextValueToAdd);


                    // 新規追加された値を form の element (<select>) に set することで、それが選択されるようにする (既存データと重複していたらそれが選択される)。
                    setValue(
                      targetToAddTextValue as never,
                      trimmedTextValueToAdd as never,
                      { shouldValidate: true, shouldDirty: true, shouldTouch: true }
                    );

                    // リセット。
                    setTextValueToAdd('');

                    // ダイアログを閉じる。
                    // setIsTextValueAddDialogOpen(false);
                    setTargetToAddTextValue('');
                  }
                }
              />
            </span>
          </div>
        </div>
      </Modal>

      {/* ドロップダウンに新規追加されたものを編集するためのダイアログ。 */}
      <Modal
        active={targetToEditOptionsData.length > 0}
        additionalClassName='mtsp popupfr865'
        displayCloseButton
        shouldCloseOnOverlayClick={false}
        onClose={
          () => {
            // ダイアログを閉じる。
            setTargetToEditOptionsData('');

            // // エラー メッセージをリセット。
            // setErrorMessagesForTextboxes([]);
          }
        }
      >
        <label>
          {
            (targetToEditOptionsData.endsWith('text_condition')) ?
              t('確定条件編集')
              :
              (targetToEditOptionsData.endsWith('dwg_no')) ?
                t('図面番号編集')
                :
                (targetToEditOptionsData.endsWith('section')) ?
                  t('Section 編集')
                  :
                  (targetToEditOptionsData.endsWith('feature')) ?
                    t('Feature 編集')
                    :
                    (targetToEditOptionsData.endsWith('item')) ?
                      t('Item 編集')
                      :
                      ''
          }
        </label>
        <br />
        <br />
        <div>
          {
            targetOptionsData.map(
              (optionData: OptionData, optionDataIndex: number) =>
                <div
                  key={optionData.value}
                  style={{
                    marginBottom: '0.5em'
                  }}
                >
                  <input
                    type="text"
                    value={editingOptionsData[optionDataIndex].value}
                    onChange={
                      (event) => {
                        if (targetToEditOptionsData.endsWith('dwg_no')) {
                          // 図面番号の場合はエラー チェックが必要。

                          if (!(event.target.value.match(/^[a-zA-Z0-9]{5}$/))) {
                            // 半角英数 5 桁という制限に違反した場合。
                            // エラー メッセージをセット。
                            setErrorMessagesForTextboxes(
                              (errorMessagesForTextboxes as any).with(optionDataIndex, toString(t('半角英数字５桁で入力してください。')))
                            );
                          }
                          else {
                            // エラー メッセージをリセット。
                            setErrorMessagesForTextboxes(
                              (errorMessagesForTextboxes as any).with(optionDataIndex, '')
                            );
                          }
                        }

                        // console.log(`event.target.value.trim(): [${event.target.value.trim()}]`);

                        // console.log('targetToEditOptionsData:', targetToEditOptionsData);

                        // ここで直接 setAddedTextConditionOptionsData() 等してしまうと、テキストボックスごと再描画されてしまうため、一文字ごとにフォーカスが外れることになる。
                        // targetOptionsData を、編集対象となるドロップダウンの新規追加された options 用データとし、それでテキストボックスを描画し、value={editingOptionsData[optionDataIndex].value} とすることで、テキストボックスの再描画を避けつつ、変更された値は editingOptionsData に保存することとする。

                        setEditingOptionsData(
                          // TODO: Array.prototype.with() の polyfill のために core-js を入れた。不要になったら core-js を削除 (cs-filter/package.json から除く) してよい。
                          // TODO: Property 'with' does not exist on type 'OptionData[]'. となるので as any としているが、core-js を import してもダメなのか？
                          (editingOptionsData as any).with(
                            optionDataIndex,
                            {
                              value: event.target.value.trim(),
                              label: event.target.value.trim(),
                            }
                          )
                        );
                      }
                    }
                  />
                  {
                    (typeof errorMessagesForTextboxes[optionDataIndex] === 'string')
                    &&
                    (errorMessagesForTextboxes[optionDataIndex].length > 0)
                    &&
                    (
                      <>
                        <br />
                        <span className="form-error">
                          {/* エラー メッセージを表示する。 */}
                          {errorMessagesForTextboxes[optionDataIndex]}
                        </span>
                        <br />
                      </>
                    )
                  }
                </div>
            )
          }
        </div>
        <div className="btnfr btnfr2w mb0">
          <div>
            <span
              className="btn2 btnbg-g"
              onClick={
                () => {
                  // ダイアログを閉じる。
                  setTargetToEditOptionsData('');

                  // // エラー メッセージをリセット。
                  // setErrorMessagesForTextboxes([]);
                }
              }
            >
              <span className="modal-close2">
                {t('キャンセル')}
              </span>
            </span>
            <span>
              <input
                type="button"
                value={toString(t('確定'))}
                className="btn1 lsp1"
                disabled={
                  errorMessagesForTextboxes.some((errorMessage: string) => (typeof errorMessage === 'string') && (errorMessage.length > 0))
                }
                // 重複チェックはしない？必要ないといえば別に無いはず。チェックする場合はエラー メッセージの表示とボタンの disabled が必要か。
                onClick={
                  () => {
                    // 編集された内容で上書き。
                    if (targetToEditOptionsData.endsWith('text_condition')) {
                      setAddedTextConditionOptionsData(editingOptionsData);
                    }
                    if (targetToEditOptionsData.endsWith('dwg_no')) {
                      setAddedDwgNoOptionsData(editingOptionsData);
                    }
                    if (targetToEditOptionsData.endsWith('section')) {
                      setAddedSectionOptionsData(editingOptionsData);
                    }
                    if (targetToEditOptionsData.endsWith('feature')) {
                      setAddedFeatureOptionsData(editingOptionsData);
                    }
                    if (targetToEditOptionsData.endsWith('item')) {
                      setAddedItemOptionsData(editingOptionsData);
                    }

                    // 対象ドロップダウンの現在選択中の option。
                    const currentValue = getValues(targetToEditOptionsData as never);

                    // 新規追加された options の変更前のものの中から探す。
                    const currentValueIndex = targetOptionsData.findIndex((targetOptionData: OptionData) => targetOptionData.value === currentValue);

                    if (currentValueIndex >= 0) {
                      // もし新規追加された options の変更前のものの中から選択されていたら。
                      setValue(
                        targetToEditOptionsData as never,
                        // 新しい値にする。
                        editingOptionsData[currentValueIndex].value as never,
                        { shouldValidate: true, shouldDirty: true, shouldTouch: true }
                      );
                    }

                    // ダイアログを閉じる。
                    setTargetToEditOptionsData('');

                    // // エラー メッセージをリセット。
                    // setErrorMessagesForTextboxes([]);
                  }
                }
              />
            </span>
          </div>
        </div>
      </Modal>

      {
        // handleSubmit() でエラーがあった場合。
        (handleSubmitErrors)
        &&
        (
          <OkModal
            onClickOk={
              () => {
                // handleSubmitErrors をクリアー。
                setHandleSubmitErrors(undefined);
              }
            }
          >
            {/* {JSON.stringify(handleSubmitErrors)} */}
            {
              // formState.errors[]?.message
              Object.getOwnPropertyNames(formState.errors).map(
                (propName: string) => {
                  const errorMessage = toString(formState.errors[propName]?.message);
                  return (
                    <div>
                      {
                        // // スキーマ定義時に設定した message を置き換えて表示する。
                        // (errorMessage === 'ps_no_prefix.required()') ?
                        //   t('管理No.接頭語は必須項目です。')
                        //   :
                        //   (errorMessage === 'derivations.min(1)') ?
                        //     t('派生は最低でも1つは登録されている必要があります。')
                        //     :
                        //     (errorMessage === 'text_conditions.min(1)') ?
                        //       t('テキスト確定条件は最低でも1つは登録されている必要があります。')
                        //       :
                        errorMessage
                      }
                    </div>
                  );
                }
              )
            }
          </OkModal>
        )
      }
    </>
  );
}

// PsTextConditionAddEditDialog.defaultProps = {
//   currentValues: undefined,
// };

export default PsTextConditionAddEditDialog;